import * as i0 from "@angular/core";
export class PopupSessionService {
    constructor() {
        this.initializationDate = new Date();
        this.dismissedPopups = [];
    }
    hasBeenDismissedForSession(popupName) {
        return this.dismissedPopups.indexOf(popupName) !== -1;
    }
    setDismissedForSession(popupName) {
        this.dismissedPopups.push(popupName);
    }
}
PopupSessionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PopupSessionService_Factory() { return new PopupSessionService(); }, token: PopupSessionService, providedIn: "root" });
